import { object, string } from "yup";
import { RESTRICTED_EMAILS } from "constants/magicLink";

export const teamManagementInvite = ({ domain }: { domain: string }) =>
  object({
    first_name: string().min(1, "Min. 1 character").required("Required"),
    last_name: string().required("Required"),
  });
